import { postData } from './apiFunctions';

export const saveTestResults = async (results) => {
  const response = await postData('/api/appointment-test-result/', results);
  return response;
};
